import { CompetencySharingTone } from "./competency-sharing";

// Colour says how far an edit reaches, not how bad it is: amber everywhere,
// blue beyond this career track, grey only here.
export const sharingToneClassName: Record<CompetencySharingTone, string> = {
  all: "bg-amber-50 text-amber-800",
  some: "bg-blue-50 text-blue-800",
  local: "bg-gray-100 text-gray-600",
};

// Section headers on the overview and in the career track tables: one grey
// for every kind, so the hierarchy is read from indentation and order rather
// than colour. (The competencies list and sharing chips keep their colours.)
export const sectionHeaderToneClassName = "bg-gray-50 text-gray-900";
// Opaque, unlike the tints above: the name column is pinned, and anything
// see-through lets the cells scrolling under it show.
export const sectionHeaderHoverToneClassName = "group-hover/row:bg-gray-100";
